import React from 'react';

const metrics = [
  {
    category: 'Standard',
    accent: 'bg-[#DBEAFE] text-[#1E3A8A]',
    items: [
      { name: 'BLEU', desc: 'N-gram precision against a reference with brevity penalty. Uses sacreBLEU. 0–100, higher is better.' },
      { name: 'chrF++', desc: 'F-score over character and word n-grams. Language- and tokenization-independent. 0–100, higher is better.' },
      { name: 'TER', desc: 'Edit distance (insertions, deletions, substitutions, shifts) to match the reference. Lower is better.' },
      { name: 'WER', desc: 'Word-level edit distance as a ratio of errors to reference length. Lower is better.' },
      { name: 'hLEPOR', desc: 'Harmonic mean of length penalty, precision, position penalty, and recall. Tunable per language pair.' },
    ],
  },
  {
    category: 'BERTScore family',
    accent: 'bg-[#EDE9FE] text-[#4C1D95]',
    items: [
      { name: 'BERTScore', desc: 'Semantic similarity via contextual embeddings. Variants (base, Large, XL, XXL) use larger models for higher accuracy. 0–100, higher is better.' },
    ],
  },
  {
    category: 'COMET family',
    accent: 'bg-[#DCFCE7] text-[#166534]',
    items: [
      { name: 'COMET', desc: 'Neural metric using source + reference, trained on human judgments. Higher is better.' },
      { name: 'XCOMET-XL / XXL', desc: 'Explainable neural metrics with error span detection categorized by MQM severity.' },
      { name: 'COMETKiwi / XL / XXL', desc: 'Reference-free quality estimation using only the source text. 0–1, higher is better.' },
    ],
  },
  {
    category: 'Google / MetricX family',
    accent: 'bg-[#FFEDD5] text-[#9A3412]',
    items: [
      { name: 'MetricX-24 Hybrid XXL', desc: 'Regression metric (mT5-based) supporting both reference-based and reference-free evaluation.' },
    ],
  },
];

const InformationSection = () => {
  return (
    <div className="mb-0">
      <div className="bg-white py-7">
        <div className="mb-6">
          <h3 className="text-2xl font-semibold text-[#0F172A]">About these metrics</h3>
          <p className="text-sm text-[#6B7280] mt-1 max-w-[820px]">
            Short, plain‑language explanations of what each metric checks and how to read it.
          </p>
        </div>

        <div className="space-y-6">
          {metrics.map((group) => (
            <div key={group.category} className="rounded-xl border border-[#E2E8F0] overflow-hidden">
              <div className="flex items-center bg-[#F8FAFC] px-4 py-3 gap-2">
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${group.accent}`}>
                  {group.category}
                </span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-[160px_1fr] gap-x-6">
                {group.items.map((m, index) => {
                  const isLast = index === group.items.length - 1;
                  return (
                    <React.Fragment key={m.name}>
                    <div className={`px-4 py-3 text-sm font-semibold text-[#0F172A] md:border-r border-[#E2E8F0] ${
                      isLast ? 'border-b-0 md:border-b-0' : 'border-b md:border-b-0'
                    }`}>
                      {m.name}
                    </div>
                    <div className={`px-4 py-3 text-sm text-[#475569] leading-relaxed ${
                      isLast ? 'border-b-0' : 'border-b border-[#E2E8F0]'
                    }`}>
                      {m.desc}
                    </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InformationSection;
